import { Component, ElementRef, Inject, Input, OnInit, Renderer2, ViewChild } from '@angular/core';
import * as fromHeaderStore from '@purplefront/header/data-access';
import { Subject } from 'rxjs';
import { Store } from '@ngrx/store';
import { FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { HeaderContainer } from '../../../../../header/feature-shell/src/lib/containers/header.container';
import * as fromAuthStore from '@purplefront/auth/data-access';
import * as fromRouterStore from '@purplefront/app-router/data-access';
import * as fromPreferencesStore from '@purplefront/preferences/data-access';
import { HeaderFacade } from '@purplefront/header/data-access';
import { Langs, ThemeService, WINDOW } from '@purplefront/shared';
import { AppRouterFacadeService } from '@purplefront/app-router/data-access';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { InterfaceLanguageService } from '@purplefront/preferences/data-access';

@Component({
  selector: 'app-header-rio',
  templateUrl: './header-rio.component.html',
  styleUrls: ['./header-rio.component.scss']
})
export class HeaderRioComponent extends HeaderContainer implements OnInit {
  @ViewChild('searchBar') searchBar: ElementRef;
  @Input() lang: string;
  public searchForm: FormGroup;
  hasExpandedSearchBox = false;
  public isOpenSuggestList$ = new Subject<boolean>();
  public searchControl: FormControl;
  public _ngUnsubscribe$: Subject<void> = new Subject<void>();
  public currentUrl: string;

  constructor(
    public _router: Router,
    public _route: ActivatedRoute,
    public _authStore: Store<fromAuthStore.AuthState>,
    public _headerStore: Store<fromHeaderStore.HeaderState>,
    public _routerStore: Store<fromRouterStore.AppRouterState>,
    public _catalogStore: Store<fromRouterStore.AppRouterState>,
    public _preferencesStore: Store<fromPreferencesStore.PreferencesState>,
    public _renderer: Renderer2,
    public _headerService: HeaderFacade,
    public _interfaceLanguageService: InterfaceLanguageService,
    public _appRouterFacade: AppRouterFacadeService,
    public _themeService: ThemeService,
    public _modalService: NgbModal,
    @Inject(WINDOW) public window: Window
  ) {
    super(
      _router,
      _route,
      _authStore,
      _headerStore,
      _routerStore,
      _catalogStore,
      _preferencesStore,
      _renderer,
      _headerService,
      _interfaceLanguageService,
      _appRouterFacade,
      _themeService,
      _modalService,
      window
    );
  }

  ngOnInit(): void {
    super.getDataFromStore();
    super.setWindowWidth();
    super.getScreenWidth();
    super.getCurrentPage();
    super.initNav();
    super.getCurrentTheme();
    this.getActiveUrl();
  }

  getActiveUrl(): void {
    this.currentUrl = this._router.url.substring(0, this._router.url.lastIndexOf('/'));
  }

  changeContentLang(lang: Langs) {
    this._preferencesStore.dispatch(fromPreferencesStore.changeContentLang({ payload: { contentLang: lang } }));
  }
}
